const STORAGE_KEY = 'lk-audio-output-device-id';

export const getPreferredAudioOutputId = () => {
	try {
		return window.localStorage.getItem(STORAGE_KEY) || '';
	} catch (error) {
		return '';
	}
};

export const savePreferredAudioOutputId = deviceId => {
	try {
		window.localStorage.setItem(STORAGE_KEY, deviceId);
	} catch (error) { }
};

export const clearPreferredAudioOutputId = () => {
	try {
		window.localStorage.removeItem(STORAGE_KEY);
	} catch (error) { }
};

export const playAudioOutputTest = async (src, deviceId) => {
	const element = document.createElement('audio');

	element.src = src;
	element.volume = 1;
	element.preload = 'auto';
	element.setAttribute('playsinline', '');
	element.style.display = 'none';

	document.body.appendChild(element);

	try {
		if (deviceId && typeof element.setSinkId === 'function') {
			await element.setSinkId(deviceId);
		}

		await element.play();
	} catch (error) {
		element.remove();

		throw error;
	}

	element.addEventListener('ended', () => element.remove(), { once: true });
	element.addEventListener('error', () => element.remove(), { once: true });
};
